<div class="welcome-container d-flex min-vh-100">
  <div class="welcome-content flex-grow-1">

    <div class="content-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8">
            <div class="text-center mt-5">

              <!-- Welcome Title -->
              <h1 class="welcome-title fade-in-delay mt-4">
                Welcome, <span class="user-name">{{ user.Name }}</span>!
              </h1>

              <!-- Subtitle -->
              <h2 class="subtitle fade-in-delay-2 mt-4">
                Unlock the power of behavioral insights with EfficX.
              </h2>

              <!-- Description -->
              <p class="description fade-in-delay-2 mt-5">
                Begin your assessment to discover your unique work style and alignment with team goals.
              </p>


              <!-- ========================================================= -->
              <!-- WHEN PROFILE NOT COMPLETED - SHOW PROFILE FORM -->
              <!-- ========================================================= -->

              <div class="mt-5" *ngIf="!isProfileCompleted">
                <div class="card shadow-sm p-4">
                  <h4 class="text-center mb-3 fw-bold" style="color:#0D1B56; font-size:28px;">Complete Your Profile</h4>

                  <p class="text-muted text-center">
                    Please complete your profile to unlock your assessment.
                  </p>

                  <form [formGroup]="profileForm" class="mt-4">

                    <div class="row g-3">

                      <!-- Email -->
                      <div class="col-md-6 fw-semibold text-start">
                        <label class="form-label" style="color:#0D1B56;">Email</label>
                        <input type="email" class="form-control" formControlName="email" placeholder="Enter your email">
                      </div>


                      <!-- Phone Number -->
                      <div class="col-md-6 fw-semibold text-start">
                        <label class="form-label" style="color:#0D1B56;">Phone Number</label>
                        <div class="input-group">
                          <input type="text" class="form-control" style="max-width: 60px" formControlName="countryCode"
                            placeholder="+91">
                          <input type="tel" class="form-control" formControlName="phoneNumber">
                        </div>
                      </div>

                      <!-- DOB -->
                      <div class="col-md-6 fw-semibold text-start">
                        <label class="form-label " style="color:#0D1B56;">Date of Birth</label>
                        <input type="date" class="form-control" formControlName="dateOfBirth">
                      </div>

                      <!-- Gender -->
                      <div class="col-md-6 fw-semibold text-start">
                        <label class="form-label" style="color:#0D1B56;">Gender</label>
                        <select class="form-select" formControlName="gender">
                          <option value="">Select…</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>

                      <!-- Has Aspiration -->
                      <div class="col-md-6 fw-semibold text-start">
                        <label class="form-label" style="color:#0D1B56;">Do you have any aspiration?</label>
                        <select class="form-select" formControlName="hasAspiration">
                          <option value="">Select…</option>
                          <option [ngValue]="true">Yes</option>
                          <option [ngValue]="false">No</option>
                        </select>
                      </div>

                      <!-- Aspiration Type -->
                      <div class="col-md-6 fw-semibold text-start"
                        *ngIf="profileForm.get('hasAspiration')?.value === true">
                        <label class="form-label" style="color:#0D1B56;">Aspiration Type</label>
                        <select class="form-select" formControlName="aspirationType" (focus)="loadAspirationTypes()">
                          <option value="">Select Aspiration Type</option>
                          <option *ngFor="let role of roles" [value]="role.roleId">
                            {{ role.careerCluster }}</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>

                      <!-- Aspiration Text -->
                      <div class="col-md-6" *ngIf="profileForm.get('aspirationType')?.value === 'Other' &&
                               profileForm.get('hasAspiration')?.value === true">
                        <label class="form-label">Describe Your Aspiration</label>
                        <input type="text" class="form-control" formControlName="aspirationText">
                      </div>

                    </div>

                    <div class="text-center mt-4">
                      <button class="btn btn-primary px-4" (click)="saveProfile()" [disabled]="profileForm.invalid">
                        Save Profile
                      </button>
                    </div>
                  </form>
                </div>
              </div>


              <!-- ========================================================= -->
              <!-- AFTER PROFILE COMPLETION - SHOW TAKE ASSESSMENT BUTTON -->
              <!-- ========================================================= -->

              <div class="fade-in-delay-3" *ngIf="isProfileCompleted && lastAssignment">
                <button type="button" class="btn btn-primary btn-md rounded mt-5 custom-hover"
                  (click)="getAllQuestionGroup(lastAssignment.assignmentId)">
                  Take Assessment
                </button>
              </div>


              <!-- No Assessments Message -->
              <div class="no-assessments text-center mt-4" *ngIf="!lastAssignment">
                <p class="text-muted">No assessments available at this time.</p>
              </div>


              <!-- Logout Button -->
              <!-- <div class="logout-section fade-in-delay-4 my-5">
                <button type="button" class="btn btn-primary btn-md" (click)="logout()">
                  Log Out
                </button>
              </div> -->

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>